import React from "react";
import MultiStep from "react-multistep";
import { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import MainSectionLayout from "../../layout/MainSectionLayout";
import StepFormLayout from "../../layout/StepFormLayout";

import InfoOrg from "../Authentication/InfoOrg";
import EnviManagement from "../Authentication/EnviManagement";
import WasteandEmissions from "../Authentication/WasteandEmissions";
import Management from "../Authentication/Management";
import InfoOrg2 from "../Authentication/InfoOrg2";
import InfoOrg3 from "../Authentication/InfoOrg3";
import { getOrDeleteRequest, getSession } from "../../utils/utils";

// import { getOrDeleteRequest } from "../../utils/utils";

const InitialForm = () => {
    const stepForm = useRef(null);
    const [form, setForm] = useState({
        name: '',
        description:'',
        company_name: '',
        address: '',
        state_id: '',
        city_id: '',
        district_id: '',
        contact_phone: '',
        contact_name: '',
        phone: '',
    });

    // const { id } = useParams();

    const getData = async () => {
    try {
        let response = await getOrDeleteRequest(
            `company/find/${getSession().company.id}`,
            'GET'
        );

        if (response.type === 'success') {
            let documentType = 'nit';
            if (response.data.dui) documentType = 'dui';
            if (response.data.other_document) documentType = 'other';

            setForm({
                name: response.data.name || '',
                description: response.data.description || '',
                company_name: response.data.company_name || '',
                address: response.data.address || '',
                contact_phone: response.data.contact_phone || '',
                contact_name: response.data.contact_name || '',
                business_sectors: response.data.business_sectors?.map((sector) => sector.id) || [],
                trade_name: response.data.trade_name || '',
                
                document_type: documentType,
                nit: response.data.nit || '',
                dui: response.data.dui || '',
                other_document: response.data.other_document || '',
                name_other_document: response.data.name_other_document || '',
                
                phone: response.data.phone || '',
                names: response.data.names || '',
                lastnames: response.data.lastnames || '',
                
                state_id: response.data.state_id || '',
                city_id: response.data.city_id || '',
                district_id: response.data.district_id || '',
                about_us: response.data.about_us || '',
                image: response.data.image || ''
            });
        } else {
            console.error('Error al obtener datos de la compañía:', response.message);
        }
    } catch (error) {
        console.error('Error en getData:', error);
    }
};

    useEffect(() => {
        getData();
    },[]);

    return (
        <MainSectionLayout id="InitialForm">
            <form className="multi-step-form initial-form overflow-y-auto">
                <MultiStep
                    // children={() => <></>}
                    ref={stepForm}
                    prevButton={{
                        title: 'Anterior',
                        style:{ 
                            display: 'none',
                        },
                    }}
                    nextButton={{
                        title: 'Siguiente',
                        id: 'next-button',
                        style:{ 
                            background: '#007A99',
                            width: '100%',
                            fontSize: '0.875rem',
                            fontWeight: '500',
                            cursor: 'pointer',
                            borderRadius: '0.375rem',
                            border: '1px solid #4FD1C5',
                            padding: '0.5rem 1rem',
                            color: '#fff',
                            transition: 'background-color 0.2s',
                        }, 
                    }}
                >
                    <StepFormLayout 
                        title="Información general" 
                        description="Por favor ingrese información sobre su organización."
                    >
                        <InfoOrg data={form} />
                    </StepFormLayout>

                    <StepFormLayout 
                        title="Información general" 
                        description="Por favor ingrese información sobre su organización."
                    >
                        <InfoOrg2 data={form} />
                    </StepFormLayout>

                    <StepFormLayout 
                        title="Información general" 
                        description="Por favor ingrese información sobre su organización."
                    >
                        <InfoOrg3 data={form} />
                    </StepFormLayout>
                </MultiStep>
            </form>
        </MainSectionLayout>
    );
};

export default InitialForm;

